import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { ReattemptTestService } from "../../services/reattemptTest.service"
import { LookUpService } from "../../services/lookupService"
import { fetchProcessType } from "../../services/fetchLearners";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { RegionManagementService } from "../../services/regionManagement.service";
import { LoginService } from "../../services/login.service";
import TC from "../../assets/pdf/T-C_ExpertMFD.pdf";
import { RegisterUserService } from "../../services/registration.service"

import {
  success, successNotification, error, errorNotification, warning,
  warningNotification,
} from "../notification/notifications";
import './table.css'
import * as moment from "moment";
import { Global_var } from '../../global/global_var';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));

const downloadAdmit = (props) => {
  var data = JSON.parse(localStorage.getItem("PersonnelData"))
  let tempdata = {
    "workflowId": data.responseObject.learnerID,

    "history": true
  }
  ReattemptTestService.getStatuscompleted(tempdata, res => {


    let admitCardDocId = res.data.responseListObject[0].additionalDetails.docId
    RegisterUserService.downloadDocumet("documentId=" + admitCardDocId + "&bucketTag=" + Global_var.CONST_BUCKET_NAME, res1 => {

      window.location.href = res1.responseObject.documentUrl
      window.$('#downloadAdmitCard').modal('hide')
    })


  })
}

export default function VerticalLinearStepper(props) {

  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [steps, setSteps] = React.useState([]);
  const [learnerData] = React.useState(props);
  const [processTypeData, setProcessTypeData] = React.useState([]);
  const [stateListForCo, setStateList] = React.useState([]);
  const [stateListForCo1, setStateList1] = React.useState(0);
  const [getGridData, setGridData] = React.useState([]);
  const [CurrentState, setCurrentState] = React.useState("");
  const [stepperList, setStepperList] = React.useState("");
  

  React.useEffect(() => {
    // window.$('#showStatusPopup').modal('show')
    //window.$('#defaultkydpopup2').modal('show')
    // window.$('#defaultkydpopup1').modal('show')
    //  window.$('#downloadAdmitCard').modal('show')
    //  window.$('#showStatusPopup').modal('show')
    // window.$('#showStatusPopup').modal('show')
    //  window.$('#defaultkydpopup').modal('show')

    var data2 = localStorage.getItem("PersonnelData")

    let result = ["REGISTERED", "PROFILE COMPLETED", "FEAT COMPLETED", "NISM VA SUBSCRIBED", "NISM VA PAYMENT COMPLETED", "NISM PROFILE CREATED",
      "NISM EXAM DATE CONFIRMED", "ADMIT CARD AVAILABLE", "NISM CERTIFICATION COMPLETED", "KYD-ARN APPLIED",
      "KYD-ARN ACCEPTED", "UNDER EMPANELMENT", "EMPANELLED"]

    setSteps(result)
    let tempdata = {
      "workflowId": learnerData.personnelProfileData.learnerID,
      // "204092",
      "history": true
    }
    ReattemptTestService.getStatuscompleted(tempdata, res => {
      console.log(res)


    var stepperList =[]
    let profilePercent = localStorage.getItem("profilecomlitionvalue") === undefined
                          ? parseInt(0)
                          : parseInt(localStorage.getItem("profilecomlitionvalue"));
    let amfiUser= learnerData.personnelProfileData.isAmfiUser
      for (var i = 0; i <= result.indexOf(res.data.responseListObject[0].state.applicationStatus); i++) {
        if (i == 1 && amfiUser === 1) {
          if (profilePercent > 60 && learnerData.personnelProfileData.applicationStatus === "SUBMITTED") {
            stepperList.push(true)
          } else {
            stepperList.push(false)
          }
        } else {
          stepperList.push(true)
        }
      }

     setStepperList(stepperList)

      //  let result1=["REGISTERED","APPLY FOR FEAT","FEAT COMPLETED"]
      localStorage.setItem("currentState", res.data.responseListObject[0].state.applicationStatus)
      setActiveStep(result.indexOf(res.data.responseListObject[0].state.applicationStatus) + 1)
      if (res.data.responseListObject[0].state.applicationStatus == "NISM PROFILE CREATED") {
        setCurrentState(res.data.responseListObject[0].state.applicationStatus)

        if (!res.data.responseListObject[0].hasOwnProperty('additionalDetails')) {
          window.$('#showStatusPopup').modal('show')

        }
        if (res.data.responseListObject[0].additionalDetails.action == "CANCEL") {
          window.$('#cancelExam').modal('show')
        }

        //window.$('#progressBarPopup').modal('show')
        //  window.$('#downloadAdmitCard').modal('show')

      }
      else if (res.data.responseListObject[0].state.applicationStatus == "ADMIT CARD AVAILABLE") {

        //alert('flag')
        let flag = false
        // res.data.responseListObject.map(e => {
        //   if (e.action = "NISM PROFILE CREATE") {
        //     flag = e.additionalDetails.flag
        //   }
        // })
        for (let i = 0; i < res.data.responseListObject.length; i++) {
          if (res.data.responseListObject[i].action == "NISM PROFILE CREATE" && res.data.responseListObject[i].state.action[0].isActive === 1) {

            flag = res.data.responseListObject[i].additionalDetails.flag
            break;
          }
        }

        // responseListObject[2].action=NISM PROFILE CREATE
        // responseListObject[2].additionalDetails.flag
        if (flag == false) {
          window.$('#downloadAdmitCard').modal('show')
        }

      }


      else if (res.data.responseListObject[0].state.applicationStatus == "NISM CERTIFICATION COMPLETED") {

        window.$('#defaultkydpopup').modal('show')


      }

      else if (res.data.responseListObject[0].state.applicationStatus == "KYD-ARN ACCEPTED") {

        window.$('#defaultkydpopup1').modal('show')


      }

      else if (res.data.responseListObject[0].state.applicationStatus == "UNDER EMPANELMENT") {


        if (!learnerData.personnelProfileData.hasOwnProperty('nomineeName')) {

          window.$('#defaultkydpopup2').modal('show')
        }

      }






    }
    )
    LoginService.TokenUser(res => {
      localStorage.setItem("jwt-token", res.responseObject);
    });

    RegionManagementService.getState(
      "countryId=1",
      //+ this.state.corcountryId,
      res => {

        console.log("resaaaaaa")
        setStateList(res.responseListObject)
        setStateList1(12345)

        console.log(stateListForCo1)
      }
    );



  }, []);
  // let dateLocation = localStorage.getItem("getDateLocationData")
  // console.log(JSON.parse(dateLocation))
  return (
    <div>
      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 mystatus">
        <h3 className="learner-title">My Status</h3>
        <div className="my-status">
          <div className="text-center">
            <span style={{ paddingRight: "15px" }}><span className="J-done">
              <i class="fa fa-stop" aria-hidden="true"></i></span> Completed</span>
            <span style={{ paddingRight: "15px" }}><span className="J-inprogress">
              <i class="fa fa-stop" aria-hidden="true"></i></span> In Progress</span>
            <span style={{ paddingRight: "15px" }}><span className="J-pending">
              <i class="fa fa-stop" aria-hidden="true"></i></span> Pending</span>
          </div>
          <div className={classes.root}>
            <Stepper activeStep={activeStep} orientation="vertical" >
              {steps && steps.map((label, index) => (

                <Step completed={stepperList[index]} key={label} data-toggle="modal" data-target="#statusPopup" data-backdrop='true' data-keyboard='true'
                // onClick={e => {
                //      localStorage.setItem("showstatusName", label)
                //  if (label == "KYD-ARN APPLIED" || label == "NISM PROFILE CREATED" || label == "ADMIT CARD AVAILABLE")
                //window.$('#statusPopup').modal('show')
                // }//
                //}
                >
                  <StepLabel>{label}</StepLabel>
                  {/* <StepContent>
           
              <div className={classes.actionsContainer}>
               
                {activeStep==5? 
                <div>
                  <Button
                    color="blue"
                    className={classes.button}
                    onClick={e=>{
                      window.$('#downloadAdmitCard').modal('show')
                    }}
                  >
                 Admit card available
                   
                  </Button>
                 
                </div>
                 :''}
              </div>
            </StepContent> */}
                </Step>
              ))}
            </Stepper>
          </div>
        </div>
      </div>





      <Formik

        initialValues={{


          picked: 'offline',
          corstateId: '',
          center: '',
          testDate: '',
          location: '',
          //dateLocation.length > 0 ? DateLocationData.responseObject.additionalDetails.stateId : '',
          //JSON.parse(dateLocation) ? JSON.parse(dateLocation).additionalDetails.centre : '',
          //JSON.parse(dateLocation) ? JSON.parse(dateLocation).additionalDetails.stateId : '',
          termsandcondition: '',
          disabled: 'false'
        }}
        validationSchema={Yup.object().shape({


          picked: Yup.string()
            .required('You must select a mode'),
          // corstateId: Yup.string()
          //   .required('You must select a state'),
          location: Yup.string()
            .required('You must select a location'),
          center: Yup.string()
            .required('You must select a center'),
          testDate: Yup.string()
            .required('You must select a Test date'),

        })}
        onSubmit={(fields) => {

          if (fields.termsandcondition === true) {
            console.log(fields)
            var data1 = localStorage.getItem("login")
            var data2 = localStorage.getItem("PersonnelData")


            let data = [{
              "action": "NISM VA PAYMENT COMPLETE",   //"REGISTER",   //CurrentState
              "workflowId": JSON.parse(data2).responseObject.learnerID,
              //JSON.parse(data2).responseObject.learnerID,
              "additionalDetails": {
                "stateId": fields.location,
                "center": fields.center,
                "requestedDate": fields.testDate,

                "flag": fields.picked == "online" ? true : false,
                "isconfirmbycilopps": false,


              }

            }]



            ReattemptTestService.UpdateWorkflow(data, res => {
              //console.log(res)
              if (res.data.status === "success" || res.data.status === "SUCCESS") {
                success(

                  "Your Date and Location Successfully Submitted",
                  successNotification
                );
                var data1 = localStorage.getItem("PersonnelData")
                let data_temp = [{
                  "userName": JSON.parse(data1).responseObject.firstName,
                  "selectedDate": fields.testDate,
                  "location": fields.center,
                  "emailId": JSON.parse(data1).responseObject.emailID,
                  "templateId": "196025",
                  "status": "Location_for_the_NISM_Exam"


                }]

                RegisterUserService.sendMail(data_temp, res => {
                })
                window.$('#statusPopup').modal('hide')

                //window.location.reload()
              }
            })
          }
          else {
            warning(

              "Please select terms and condition",
              warningNotification
            );
          }
        }}

        render={({ errors, touched, handleSubmit, setFieldValue, values }) => (
          <React.Fragment>


            <div class="modal hide fade" id="myModal">
              <div class="modal-header">
                <a class="close" data-dismiss="modal">×</a>
                <h3>Modal header</h3>
              </div>
              <div class="modal-body">
                <p>One fine body…</p>
              </div>
              <div class="modal-footer">
                <a href="#" class="btn">Close</a>
                <a href="#" class="btn btn-primary">Save changes</a>
              </div>
            </div>
            <div
              className="modal fade"
              id="statusPopup1"
              tabindex="-1" role="dialog" aria-labelledby="modalLabel" data-keyboard="true" aria-hidden="true"
            >

              <div className="modal-dialog modal-md" role="document">
                <Form onSubmit={handleSubmit} className="form_name">
                  <div className="modal-content">
                    <button
                      type="reset"
                      class="close"
                      aria-label="Close"
                      onClick={
                        e => {
                          window.$('#statusPopup').modal('hide')
                        }
                      }
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>

                    <section className="registration">
                      <div className="modal-body">
                        <div classNames="container">
                          <div className="modal-head" style={{
                            padding: "9px 8px"
                          }}>
                            <div className="section-title-black" style={{ textAlign: "center" }} >
                              <h3 style={{ color: "black" }} >NISM Certification Schedule</h3>
                            </div>
                          </div>
                          <div className="">

                            <div>


                            </div>

                            <div className="col-md-12">
                              <div className="form-group">
                                <label
                                  class="form-check-label"
                                  htmlFor="gridCheck"
                                  style={{ marginRight: "15px" }}
                                >
                                  Mode
                                  <span className="validation"> *</span>
                                </label>
                                <div>


                                  <Field type="radio" onClick={e => {

                                    setFieldValue(values.disabled = "false")

                                  }} name="picked" value="offline" style={{ marginRight: "10px" }} className="form-check-input" />
                                  <label
                                    class="form-check-label"
                                    htmlFor="gridCheck"
                                    style={{ marginRight: "15px" }}
                                  >
                                    Offline
                                            </label>


                                  <Field type="radio" name="picked" onClick={e => {
                                    warning(

                                      "coming soon",
                                      warningNotification
                                    );
                                    setFieldValue(values.testDate = "")
                                    setFieldValue(values.location = "")
                                    setFieldValue(values.center = "")

                                    // setFieldValue(values.disabled = "true")
                                    setFieldValue(values.disabled = "true")

                                  }} className="form-check-input" style={{ marginRight: "10px" }} value="online" />
                                  <label
                                    class="form-check-label"
                                    htmlFor="gridCheck"
                                    style={{ marginRight: "15px" }}
                                  >
                                    Online
                                            </label>
                                  <ErrorMessage
                                    name="picked"
                                    className="validation"
                                    component="div"
                                  />
                                </div>
                                <label>Test Date
                                  <span className="validation"> *</span>
                                </label>
                                <Field type="date"
                                  name="testDate"
                                  id="testDate"
                                  autoComplete="testDate"
                                  disabled={values.disabled == "true" ? true : false}
                                  className={
                                    "form-control" +
                                    (errors.testDate && touched.testDate
                                      ? " is-invalid"
                                      : "")
                                  }

                                />
                                <ErrorMessage
                                  name="testDate"
                                  className="validation"
                                  component="div"
                                />
                                <label>Select Location
                                   <span className="validation"> *</span>
                                </label>
                                <Field
                                  as="select"
                                  name="location"
                                  id="location"
                                  autoComplete="location"
                                  disabled={values.disabled == "true" ? true : false}
                                  onChange={event => {
                                    console.log(event.target.value)


                                    LoginService.TokenUser(res => {
                                      localStorage.setItem(
                                        "jwt-token",
                                        res.responseObject
                                      );
                                    });
                                    if (
                                      event.target.value !== undefined
                                    ) {

                                      setFieldValue(
                                        (values.location =
                                          event.target.value)
                                      );
                                      RegionManagementService.getCenter(
                                        "stateId=" + event.target.value,
                                        res => {
                                          setFieldValue(
                                            (values.centerList =
                                              res.responseListObject)
                                          );
                                        }
                                      );

                                    }
                                  }}
                                  className={
                                    "form-control" +
                                    (errors.location &&
                                      touched.location
                                      ? " is-invalid"
                                      : "")
                                  }
                                  placeholder="location"
                                >
                                  <option>--Select--</option>
                                  {(stateListForCo || []).map(
                                    team => (
                                      <option
                                        key={team.stateId}
                                        value={team.stateId}
                                      >
                                        {(team.stateName)}
                                      </option>
                                    )
                                  )}
                                </Field>
                                <ErrorMessage
                                  name="location"
                                  className="validation"
                                  component="div"
                                />
                                <label>Select Center
                                   <span className="validation"> *</span>
                                </label>
                                <Field
                                  as="select"
                                  name="center"
                                  id="center"
                                  autoComplete="center"
                                  disabled={values.disabled == "true" ? true : false}
                                  className={
                                    "form-control" +
                                    (errors.center &&
                                      touched.center
                                      ? " is-invalid"
                                      : "")
                                  }
                                  placeholder="Quartlet"
                                >
                                  <option>--Select--</option>

                                  {(values.centerList || []).map(
                                    team => (
                                      <option
                                        key={team.centerName}
                                        value={team.centerName}
                                      >
                                        {(team.centerName)}
                                      </option>
                                    )
                                  )}
                                </Field>
                                <ErrorMessage
                                  name="center"
                                  className="validation"
                                  component="div"
                                />


                              </div>
                            </div>
                            <div className="col-md-12 col-sm-12 col-xs-12">

                              <Field
                                className="form-check-input"
                                type="checkbox"
                                name="termsandconditions"
                                onClick={e => {

                                  setFieldValue(
                                    (values.termsandcondition =
                                      true)
                                  );
                                }}

                                style={{ marginRight: "10px" }}
                              />
                              <span
                                class="form-check-label"
                                for="gridCheck"
                                style={{ marginRight: "15px" }}
                              >
                                <a href={TC} target="_blank" >Terms and Conditions
                                <span className="validation"> *</span>
                                </a>
                              </span>
                            </div>
                          </div>
                          <div className="mb-20 text-center">
                            <button type="submit" className="btn-5 mr-20">Submit</button>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </Form>
              </div>

            </div>
          </React.Fragment>
        )}
      />







      <Formik

        initialValues={{

          data: [{ "nodeName": "Chapter 1 Growth Mindset", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Scorm 1.2", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1730 }, { "nodeName": "Chapter 2 Grit and Resilience", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Scorm 1.2", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1731 }, { "nodeName": "Chapter 3 Communication Presentation and Networking", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Scorm 1.2", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1732 }, { "nodeName": "Chapter 4 Grooming", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Scorm 1.2", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1733 }, { "nodeName": "Chapter 5 Time Management", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Scorm 1.2", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1734 }, { "nodeName": "Session 1 - Investor Psychology; An Introduction - QUIZ", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Assessment", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1735 }, { "nodeName": "Session 2 - Investor Psychology Understanding Biases and Avoiding Pitfalls_QUIZ", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Assessment", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1736 }, { "nodeName": "Session 3 for Developing the RIGHT Mindset Consultative Selling_QUIZ", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Assessment", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1737 }, { "nodeName": "Session 4 - Risk, Return and Asset Allocation_ Quiz", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Assessment", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1738 }, { "nodeName": "Session 5 - Personal finance & investment planning", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Assessment", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1739 }],

        }}

        onSubmit={(fields) => {

          var data1 = localStorage.getItem("login")
          var data2 = localStorage.getItem("PersonnelData")


          let data = [{
            "userName": JSON.parse(data1).userName,
            "userId": JSON.parse(data1).userId,
            "emailId": JSON.parse(data1).emailId,
            "passward": "",
            "templateId": "196011",
            "mobileNumber": JSON.parse(data2).responseObject.mobileNo
          }]
          // reattemptSendMail(data, this.props.history, res => {
          //   console.log(res)
          //   // this.props.history.push("/learnerDashboard");
          //   // window.location.reload()
          //   // if (res.status === "success") {
          //   //   success(
          //   //     "Mail send successfully",
          //   //     successNotification
          //   //   );
          //   //   this.props.history.push("/learnerDashboard");
          //   //   window.location.reload()
          //   // }
          //   // else {
          //   //   warning(

          //   //     "",
          //   //     warningNotification
          //   //   );

          //   // }
          // });


        }}

        render={({ errors, touched, handleSubmit, setFieldValue, values }) => (
          <React.Fragment>


            <div class="modal hide fade" id="myModal">
              <div class="modal-header">
                <a class="close" data-dismiss="modal">×</a>
                <h3>Modal header</h3>
              </div>
              <div class="modal-body">
                <p>One fine body…</p>
              </div>
              <div class="modal-footer">
                <a href="#" class="btn">Close</a>
                <a href="#" class="btn btn-primary">Save changes</a>
              </div>
            </div>
            <div
              className="modal fade"
              id="progressBarPopup"
              tabindex="-1" role="dialog" aria-labelledby="modalLabel" data-keyboard="true" aria-hidden="true"
            >

              <div className="modal-dialog modal-md" role="document">
                <Form onSubmit={handleSubmit} className="form_name">
                  <div className="modal-content">
                    <button
                      type="button"
                      class="close"
                      //   aria-label="Close"
                      onClick={
                        e => {
                          window.$('#progressBarPopup').modal('hide')
                        }
                      }
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>

                    <section className="registration">
                      <div className="modal-body">
                        <div classNames="container">
                          <div className="modal-head" style={{
                            padding: "9px 8px"
                          }}>
                            <div className="" style={{ textAlign: "center" }} >
                              <h3 style={{ color: "black" }} >CIEL LOGO</h3>
                              <h5 style={{ color: "black" }} >Company Slogan</h5>
                              <h5 style={{ color: "black" }} >This certificate is awaited to<b> {learnerData.personnelProfileData.firstName} {learnerData.personnelProfileData.lastName} </b>for successfully completing the NISM training</h5>
                            </div>

                          </div>
                          <div className="">
                            <center>
                              <h5 style={{ color: "black" }} >NISM VA content node 90%</h5>
                              <table id="progressstatusPopup">
                                <tr>
                                  {/* <th></th>
                                  <th></th> */}

                                </tr>
                                {values.data.map((e, index) => {
                                  return (
                                    <tr>
                                      <td>{e.nodeName}</td>
                                      <td>{e.score}</td>
                                      <td>{e.nodeStatus}</td>
                                    </tr>
                                  )
                                })}
                                <td>Refresher</td>
                                <td>90%</td>
                                <td></td>


                              </table>

                            </center>
                            <br /> <br />
                            <div style={{ float: "right" }}>
                              CIEL Signatory
  </div>
                            <br />
                            <br /> <br />
                          </div>

                        </div>
                      </div>
                    </section>
                  </div>
                </Form>
              </div>

            </div>
          </React.Fragment>
        )}
      />



      <Formik

        initialValues={{


          picked: 'offline',
          corstateId: '',
          center: '',
          testDate: '',
          location: '',
          //dateLocation.length > 0 ? DateLocationData.responseObject.additionalDetails.stateId : '',
          //JSON.parse(dateLocation) ? JSON.parse(dateLocation).additionalDetails.centre : '',
          //JSON.parse(dateLocation) ? JSON.parse(dateLocation).additionalDetails.stateId : '',
          termsandcondition: '',
          disabled: 'false'
        }}
        validationSchema={Yup.object().shape({


          picked: Yup.string()
            .required('You must select a mode'),
          // corstateId: Yup.string()
          //   .required('You must select a state'),
          location: Yup.string()
            .required('You must select a location'),
          center: Yup.string()
            .required('You must select a center'),
          testDate: Yup.string()
            .required('You must select a Test date'),

        })}
        onSubmit={(fields) => {

          if (fields.termsandcondition === true) {
            console.log(fields)
            var data1 = localStorage.getItem("login")
            var data2 = localStorage.getItem("PersonnelData")


            let data = [{
              "action": "NISM VA PAYMENT COMPLETE",   //"REGISTER",   //CurrentState
              "workflowId": JSON.parse(data2).responseObject.learnerID,
              //JSON.parse(data2).responseObject.learnerID,
              "additionalDetails": {
                "stateId": fields.location,
                "center": fields.center,
                "requestedDate": fields.testDate,

                "flag": fields.picked == "online" ? true : false,
                "isconfirmbycilopps": false,


              }

            }]



            ReattemptTestService.UpdateWorkflow(data, res => {
              //console.log(res)
              if (res.data.status === "success" || res.data.status === "SUCCESS") {
                success(

                  "Your Date and Location Successfully Submitted",
                  successNotification
                );
                var data1 = localStorage.getItem("PersonnelData")
                let data_temp = [{
                  "userName": JSON.parse(data1).responseObject.firstName,
                  "selectedDate": fields.testDate,
                  "location": fields.center,
                  "emailId": JSON.parse(data1).responseObject.emailID,
                  "templateId": "196025",
                  "status": "Location_for_the_NISM_Exam"


                }]

                RegisterUserService.sendMail(data_temp, res => {
                })
                window.$('#statusPopup').modal('hide')

                //window.location.reload()
              }
            })
          }
          else {
            warning(

              "Please select terms and condition",
              warningNotification
            );
          }
        }}

        render={({ errors, touched, handleSubmit, setFieldValue, values }) => (
          <React.Fragment>


            <div class="modal hide fade" id="myModal">
              <div class="modal-header">
                <a class="close" data-dismiss="modal">×</a>
                <h3>Modal header</h3>
              </div>
              <div class="modal-body">
                <p>One fine body…</p>
              </div>
              <div class="modal-footer">
                <a href="#" class="btn">Close</a>
                <a href="#" class="btn btn-primary">Save changes</a>
              </div>
            </div>
            <div
              className="modal fade"
              id="downloadAdmitCard"
              tabindex="-1" role="dialog" aria-labelledby="modalLabel" data-keyboard="true" aria-hidden="true"
            >

              <div className="modal-dialog modal-md" role="document">
                <Form onSubmit={handleSubmit} className="form_name">
                  <div className="modal-content">
                    <button
                      type="reset"
                      class="close"
                      aria-label="Close"
                      onClick={
                        e => {
                          window.$('#downloadAdmitCard').modal('hide')
                        }
                      }
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>

                    <section className="registration">
                      <div className="modal-body">
                        <div classNames="container">
                          <div className="modal-head" style={{
                            padding: "9px 8px"
                          }}>
                            <div className="section-title-black" style={{ textAlign: "center" }} >
                              <h3 style={{ color: "black" }} >NISM Admit Card Available</h3>
                            </div>
                          </div>
                          <div className="">
                            <div className="form-group text-center">
                              <p>
                                Your NISM Registration is completed and your Admit card is now available.
                              </p>
                              <a onClick={downloadAdmit} target="_blank" >Click here to Download
                                </a>
                            </div>
                          </div>
                          <div className="">
                            {/* <button type="submit" className="btn-5 mr-20">Submit</button> */}
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </Form>
              </div>

            </div>
          </React.Fragment>
        )}
      />




    </div>
  );
}
